<template>
<div>
  <b-modal size = "lg" ref="modal" id="modal-scrollable" ok-only @hidden="$emit('ok')" :static="false">
    <template slot="modal-title">
      {{title}}
    </template>
    <div class="row" v-show = "imageFullscreen == false">
      <div class="col-lg-6">
        <div ref="parentGrafico">
          <div ref="grafico" class="card">
            <div class="card-header no-border">
              <div class="d-flex justify-content-between">
                <div class="d-flex justify-content-between">
                  <h3 class="card-title">Histórico de Potenciales</h3>
                </div>
                <div class="card-tools d-none d-xl-block d-lg-block">
                  <a class="btn btn-sm btn-tool" @click="imageFullscreen = !imageFullscreen; componentType = 'graphic'">
                    <fa-icon :icon="imageFullscreen ? 'compress':'expand'" />
                  </a>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="position-relative">
                <!--<canvas id="visitors-chart" height="200"></canvas>-->
                <bar-chart ref="chart" :chart-data="chartdata" :options="chartoptions" :height="200"></bar-chart>
              </div>
            </div>
          </div>
        </div>
        <!-- /.card -->
        <div class="card">
          <div class="card-header no-border">
            <h3 class="card-title">Mediciones</h3>
          </div>
          <div class="card-body p-0">
            <b-table hover striped :items="tabledata" :fields="tablefields" small>
              <template slot="value" slot-scope="data">
                <div class="text-nowrap">
                  {{data.item[4]}}
                  <small :class="'mr-1 ' + (data.item[4] < data.item[5] ?
                    'text-success' : (data.item[4] > data.item[5] ? 'text-danger' : 'text-warning'))">

                    <fa-icon :icon="(data.item[4] < data.item[5] ?
                    'arrow-down' : (data.item[4] > data.item[5] ? 'arrow-up' : 'dot-circle'))" />
                    <!--{{ Math.round(100 - 100 * data.item[4] / data.item[5]) || 0}}% -->
                  </small>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div ref="parentImagenes">
          <div ref="imagenes" class="card" v-if="attachments && attachments.length">
            <div class="card-header">
              <div class="d-flex justify-content-between">
                <h3 class="card-title">Registro fotográfico</h3>
              </div>
              <div class="card-tools d-none d-xl-block d-lg-block">
                <a class="btn btn-sm btn-tool" @click="imageFullscreen = !imageFullscreen; componentType = 'image'">
                  <fa-icon :icon="imageFullscreen ? 'compress':'expand'" />
                </a>
              </div>
            </div>
            <div class="card-body">
              <div class="position-relative">
                <b-carousel id="carousel" indicators controls :interval="0">
                  <b-carousel-slide v-for="(att, i) in attachments" :key = "i"
                    :img-src="att?att.url:''"
                  >{{att?att.pk:''}}</b-carousel-slide>
                </b-carousel>
              </div>
            </div>
          </div>
        </div>
        <template v-if="catodicodata">
          <div class="card" v-if="catodicodata.observations != '' || catodicodata.observations != null">
            <div class="card-header no-border">
              <h3 class="card-title">Observaciones</h3>
            </div>
            <div class="card-body">{{catodicodata.observations}}</div>
          </div>
          <div class="card" v-if="catodicodata.recomendations != '' || catodicodata.recomendations != null">
            <div class="card-header no-border">
              <h3 class="card-title">Recomendaciones</h3>
            </div>
            <div class="card-body">{{catodicodata.recomendations}}</div>
          </div>
          <div class="card" v-if="catodicodata.excuse != '' || catodicodata.excuse != null">
            <div class="card-header no-border">
              <h3 class="card-title">¿No se pudo realizar medición? Causas:</h3>
            </div>
            <div class="card-body">{{catodicodata.excuse}}</div>
          </div>
        </template>
      </div>
    </div>
    <div class="row" v-show = "imageFullscreen">
      <div class="col-lg-12" ref="parentFullscreen">
      </div>
    </div>
  </b-modal>
</div>
</template>
<script>
import { mapActions } from 'vuex'
import BarChart from '../chart/BarChart.vue'

export default {
  components: {
    BarChart
  },
  data () {
    return {
      imageFullscreen: false,
      componentType: null,
      title: '',
      catodicos: [],
      scatodico: null,
      catodicodata: null,
      metalocaciones: null,
      attachments: [],
      tabledata: [],
      tablefields: [
        {
          key: '0',
          label: 'Fecha',
          sortable: true
        },
        {
          key: '1',
          label: 'Pot. On',
          sortable: true
        },
        {
          key: '2',
          label: 'Pot. Off',
          sortable: true
        },
        {
          key: '3',
          label: 'Pot. Natural',
          sortable: true
        }
      ],
      chartdata: {
        labels: [10, 10],
        datasets: [
          {
            label: 'data',
            backgroundColor: '#f87979',
            data: [10, 10]
          }
        ]
      },
      chartoptions: {
        elements: {
          line: {
            tension: 0
          }
        },
        animation: {
          duration: 0
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          labels: {
            filter: function (item, chart) {
              return !item.text.includes('IFRM')
            }
          }
        },
        scales: {
          xAxes: [
            {
              ticks: {
                userCallback: function (label, index, labels) {
                  var date = new Date(label)
                  // return '  ' + months[date.getMonth()] + ' ' + date.getFullYear().toString().substr(-2)
                  return '   ' + (date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear().toString().substr(-2)) + '   '
                },
                callback (value, index) {
                  var months = [' ', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Set',
                    'Oct', 'Nov', 'Dic']
                  if (value.length === 9) {
                    return '  ' + months[parseInt(value.toString().substr(0, 2))] + ' ' + value.toString().substr(-4)
                  } else {
                    return ' '
                  }
                }
              },
              type: 'time',
              time: {
                unit: 'month',
                displayFormats: {
                  month: 'MM - YYYY'
                }
              }
            }
          ],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'MVDC'
            },
            ticks: {
              beginAtZero: true,
              reverse: true,
              suggestedMin: -1600
            }
            // afterBuildTicks: function (chartObj) {
            //   chartObj.ticks = [0, 10, 20, 32, 42, 50]
            // }
          }]
        },
        tooltips: {
          callbacks: {
            title: function (tooltipItems, data) {
              var tooltipItem = tooltipItems[0]
              var date = new Date(tooltipItem.xLabel)
              var label = (date.getDate().toString().padStart(2, '0') + '-' +
                (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
                date.getFullYear())
              return label
            },
            label: function (tooltipItem, data) {
              var label = 'IFRM ' + Math.round(tooltipItem.yLabel * 100) / 100
              return label
            }
          }
        },
        onClick: this.chartClick
      },
      chartplugins: [],
      metadata: null
    }
  },
  props: {
    catodico: Object
  },
  watch: {
    catodico (to, from) {
      this.catodicodata = {}
      Object.assign(this.catodicodata, to)
      this.loadCatodicos()
    },
    scatodico (to, from) {
      if (to !== null) {
        let fields = ['_id', '_rev', 'identification', 'excuse', 'measurement', 'observations', 'recomendations', 'username']
        fields.forEach(elemento => this.$set(this.catodicodata, elemento, this.catodicos[this.scatodico][elemento]))
        this.loadTable()
        this.loadAttachments()
      }
    },
    imageFullscreen (to, from) {
      if (to) {
        switch (this.componentType) {
          case 'image':
            this.$refs.parentFullscreen.appendChild(this.$refs.imagenes)
            break
          case 'graphic':
            this.$refs.parentFullscreen.appendChild(this.$refs.grafico)
        }
      } else {
        switch (this.componentType) {
          case 'image':
            this.$refs.parentImagenes.appendChild(this.$refs.imagenes)
            break
          case 'graphic':
            this.$refs.parentGrafico.appendChild(this.$refs.grafico)
        }
      }
    }
  },
  mounted () {
    var obj = this
    import('../../configuration/json/catodico.json').then(function (met) {
      obj.metadata = met
      var metalocaciones = {}
      for (var i in met.identification.children.location.choices) {
        var loc = met.identification.children.location.choices[i]
        metalocaciones[loc.value] = { display_name: loc.display_name, choices: {} }
        for (var j in loc.choices) {
          metalocaciones[loc.value].choices[loc.choices[j].value] = loc.choices[j].display_name
        }
      }
      obj.$set(obj, 'metalocaciones', metalocaciones)
    })
  },
  methods: {
    ...mapActions([
      'get_db'
    ]),
    loadCatodicos () {
      let obj = this
      if (obj.catodicodata && obj.catodicodata._id) {
        obj.title = obj.catodicodata.unity
        obj.get_db({ json: 'catodico' }).then(function (db) {
          db.find({
            selector: {
              'identification.location.flowline': {
                '$eq': obj.catodicodata.identification.location.flowline
              },
              'identification.location.progressive': {
                '$eq': obj.catodicodata.identification.location.progressive
              }
            }
          }).then(function (selection) {
            obj.catodicos = selection.docs
            obj.loadPlot()
            obj.loadTable()
            obj.loadAttachments()
          })
        })
        this.scatodico = null
        obj.imageFullscreen = false
        obj.componentType = null
        obj.$refs['modal'].show()
      }
    },
    chartClick (event, array) {
      if (array && array.length) {
        this.$set(this, 'scatodico', parseInt(array[0]._index))
      }
    },
    loadTable () {
      var obj = this
      // obj.$set(obj, 'tabledata', [row])
      obj.tabledata = []
      for (var i in obj.catodicos) {
        let row = {
          0: obj.catodicos[i].identification.date,
          1: obj.catodicos[i].measurement.pot_on,
          2: obj.catodicos[i].measurement.pot_off,
          3: obj.catodicos[i].measurement.pot_natural
        }
        if (obj.catodicos[i]._id === obj.catodicodata._id) {
          row._rowVariant = 'primary'
        }
        obj.tabledata.push(row)
      }
    },
    loadPlot () {
      var obj = this
      var dataOn = []
      var dataOff = []
      var dataNatural = []
      var data850 = []
      // var colors = []
      // var borders = []
      for (var i in obj.catodicos) {
        var cat = obj.catodicos[i]
        var elem = {
          x: new Date(cat.identification.date || '2000-01-01'),
          y: cat.measurement.pot_on
        }
        elem.x = new Date(elem.x.getTime() + elem.x.getTimezoneOffset() * 60000)
        dataOn.push(elem)
        data850.push({ x: elem.x, y: -850 })

        elem = {
          x: new Date(cat.identification.date || '2000-01-01'),
          y: cat.measurement.pot_off || null
        }
        elem.x = new Date(elem.x.getTime() + elem.x.getTimezoneOffset() * 60000)
        if (elem.y !== null) { dataOff.push(elem) }

        elem = {
          x: new Date(cat.identification.date || '2000-01-01'),
          y: cat.measurement.pot_natural || null
        }
        elem.x = new Date(elem.x.getTime() + elem.x.getTimezoneOffset() * 60000)
        if (elem.y !== null) { dataNatural.push(elem) }
      }
      var d1 = dataOn[0].x
      var d2 = dataOn[dataOn.length - 1].x
      if (d1 === d2) { d2 = new Date(d1.valueOf() + 1 * 24 * 60 * 60) }
      this.$set(this, 'chartdata', {
        datasets: [
          {
            type: 'line',
            label: 'Potencial On',
            fill: false,
            showLine: true,
            pointRadius: 2,
            pointHoverRadius: 1,
            borderWidth: 2,
            borderColor: 'rgb(0,176,80)',
            data: dataOn
          },
          {
            type: 'line',
            label: 'Potencial Off',
            fill: false,
            showLine: true,
            pointRadius: 2,
            pointHoverRadius: 1,
            borderWidth: 2,
            borderColor: 'rgb(255,0,0)',
            data: dataOff
          },
          {
            type: 'line',
            label: 'Potencial Natural',
            fill: false,
            showLine: true,
            pointRadius: 2,
            pointHoverRadius: 1,
            borderWidth: 2,
            borderColor: 'rgb(128,100,162)',
            data: dataNatural
          },
          {
            type: 'line',
            label: 'Línea Límite',
            fill: false,
            showLine: true,
            pointRadius: 0,
            pointHoverRadius: 1,
            borderWidth: 2,
            borderColor: 'rgb(255,192,0)',
            data: data850
          }
        ]
      })
      // obj.$refs['chart'].renderChart()
    },
    loadAttachments () {
      var obj = this
      obj.attachments = []
      var p = Promise.resolve(0)
      if (obj.catodicos) {
        obj.get_db({ json: 'catodico' }).then(function (db) {
          var indexes = []
          for (var i in obj.catodicos) {
            var cat = obj.catodicos[i]
            if (cat._id === obj.catodicodata._id) {
              for (var j in cat.image) {
                indexes.push({
                  _id: cat._id,
                  attachment: j,
                  pk: obj.metalocaciones[cat.identification.location.flowline].choices[cat.identification.location.progressive]
                })
              }
            }
          }
          for (i in indexes) {
            p = p.then(function (i) {
              return function () {
                return db.getAttachment(indexes[i]._id, indexes[i].attachment, { attachments: true, binary: true })
                  .then(function (img) {
                    obj.attachments.push({
                      url: window.URL.createObjectURL(img),
                      pk: indexes[i].pk
                    })
                  }).catch(function (err) {
                    console.log(err)
                  })
              }
            }(i))
          }
        })
      }
    }
  }
}
</script>
<style>
@media (min-width: 768px) {
  .modal-lg {
    width: 90% !important;
   max-width:1200px !important;
  }
}
#sidebar-overlay {
  z-index: 1037 !important;
}
.main-sidebar {
  z-index: 1038 !important;
}
.leaflet-pseudo-fullscreen {
  z-index: 1039 !important;
}
</style>
